let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("37i6a")).then(() => parcelRequire('eWrtG'));